import { createRegex, createResult, regexSeparation } from "../utils/util.js";

export function handleTextFieldChange(setValue) {
  return (event) => {
    setValue(event.target.value);
  };
}

export function regexProcessing(regex) {
  const splitRegex = regexSeparation(regex);
  const absLocation = Math.abs(Number(splitRegex[1])) || 0;
  const dollarSigns = "$".repeat(absLocation);
  const result = `${dollarSigns} ${splitRegex[0]} ...`;
  return result;
}

export function updateResult(keyword, location) {
  const absLocation = Math.abs(Number(location)) || 0;
  const dollarSigns = "$".repeat(absLocation);

  if (keyword) {
    if (location !== null && location !== "" && location !== "0") {
      return `${dollarSigns} ${keyword} ...`;
    }
    return `${keyword}`;
  }

  return ``;
}

export function handleNumberChange(setValue) {
  return (event) => {
    setValue(Number(event.target.value));
  };
}
